var _ellipse, _path, _path2, _ellipse2, _ellipse3, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSearchResultSplash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 104,
    viewBox: "0 0 124 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.196,
    cy: 52,
    rx: 51.8301,
    ry: 52,
    fill: "#E1F0EE",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6136 65.7545C29.6114 65.2876 30.7975 65.7208 31.2628 66.7218C31.728 67.7229 31.2963 68.9129 30.2985 69.3797L23.0718 72.7606C22.074 73.2274 20.8879 72.7943 20.4226 71.7933C19.9573 70.7922 20.389 69.6022 21.3868 69.1354L28.6136 65.7545Z",
    fill: "#C0E3E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3343 72.0375C29.7996 73.0386 29.3679 74.2286 28.3701 74.6954C27.3723 75.1622 26.1862 74.7291 25.7209 73.728L22.351 66.4775C21.8857 65.4765 22.3174 64.2865 23.3153 63.8197C24.3131 63.3529 25.4991 63.786 25.9644 64.7871L29.3343 72.0375Z",
    fill: "#C0E3E0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.02,
    cy: 18.8002,
    rx: 3.58823,
    ry: 3.6,
    stroke: "#C0E3E0",
    strokeWidth: 5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.77118,
    cy: 33.6002,
    rx: 6.37909,
    ry: 6.4,
    stroke: "#C0E3E0",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.436 41.9987L90.7612 42.4927C97.1141 52.1442 94.3143 65.2986 84.5903 71.7015C74.8668 78.104 61.6808 75.4768 55.3288 65.8254L55.0037 65.3313C48.6517 55.6799 51.4519 42.5263 61.1753 36.1238C70.8984 29.7215 84.0837 32.3481 90.436 41.9987Z",
    fill: "white",
    stroke: "#BECBE0",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7809 73.436L98.3509 95.7049",
    stroke: "#BECBE0",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.032 33.5534L38.0319 33.5534L38.0319 33.5617C38.025 34.5856 38.3722 35.4928 39.1162 36.1818C39.8698 36.8795 40.8123 37.1398 41.8365 37.0132C42.7597 36.8991 43.5403 36.4645 44.1392 35.7489C44.7313 35.0415 45.0356 34.2021 45.0538 33.2732C45.0728 32.4957 45.2421 31.8084 45.5494 31.196C45.8794 30.5384 46.5257 29.5914 47.5364 28.3333C48.8965 26.6684 49.8839 25.0784 50.4551 23.5654C51.0384 22.0201 51.2131 20.3675 50.9978 18.6261C50.6457 15.7774 49.344 13.4332 47.1165 11.6462C44.8265 9.80908 41.8583 9.18212 38.3488 9.61591C36.1742 9.88471 34.285 10.5992 32.72 11.7898C31.2057 12.9419 30.0229 14.3275 29.1885 15.9452L29.1828 15.9563L29.1774 15.9675C28.7584 16.8319 28.7258 17.7528 29.0427 18.666C29.3864 19.6562 30.107 20.3248 31.1174 20.5958C31.9243 20.832 32.7303 20.7503 33.4848 20.3744C34.2293 20.0034 34.797 19.4205 35.1864 18.6712L35.1882 18.6678C35.5265 18.0105 36.0123 17.4225 36.6631 16.9045C37.2355 16.4487 38.0378 16.1236 39.1364 15.9878C40.7433 15.7892 41.9131 16.0926 42.7712 16.7618C43.6687 17.4619 44.1969 18.4 44.3515 19.6501C44.4768 20.6638 44.2914 21.6613 43.7647 22.6667C43.1983 23.7479 42.3238 24.9863 41.1166 26.3846C40.0675 27.5698 39.2795 28.724 38.792 29.8473C38.3002 30.9802 38.052 32.2201 38.032 33.5534ZM39.9456 48.5677C40.9203 49.3279 42.0503 49.6402 43.2773 49.4886C44.5042 49.3369 45.5242 48.7589 46.2845 47.7841C47.0448 46.8094 47.357 45.6794 47.2054 44.4524C47.0537 43.2255 46.4757 42.2055 45.501 41.4452C44.5262 40.685 43.3962 40.3727 42.1693 40.5243C40.9423 40.676 39.9223 41.254 39.162 42.2288C38.4018 43.2035 38.0895 44.3335 38.2412 45.5605C38.3928 46.7874 38.9708 47.8074 39.9456 48.5677Z",
    fill: "#7FBEB8",
    stroke: "#7FBEB8",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResultSplash);
export default __webpack_public_path__ + "static/media/no-search-result-splash.507fc93c11ff88b65508a87e220e0120.svg";
export { ForwardRef as ReactComponent };